// Language Skills organized by subcategories
export const LANGUAGE_SKILLS_CATEGORIES = [
  {
    name: 'Speaking and Pronunciation',
    skills: [
      'Oral Communication', 'Pronunciation', 'Accent Reduction',
      'Public Speaking', 'Conversation Skills', 'Speech Fluency',
      'Voice Modulation', 'Speaking Clarity', 'Verbal Expression',
      'Presentation Skills', 'Phonetics', 'Speech Rhythm',
      'Intonation', 'Articulation', 'Speaking Confidence'
    ]
  },
  {
    name: 'Listening and Comprehension',
    skills: [
      'Active Listening', 'Audio Comprehension', 'Listening Analysis',
      'Sound Recognition', 'Context Understanding', 'Accent Understanding',
      'Speech Recognition', 'Listening Focus', 'Detail Recognition',
      'Comprehension Speed', 'Memory Retention', 'Information Processing',
      'Auditory Learning', 'Listening Strategy', 'Critical Listening'
    ]
  },
  {
    name: 'Reading and Literature',
    skills: [
      'Reading Comprehension', 'Speed Reading', 'Critical Reading',
      'Text Analysis', 'Literature Study', 'Reading Strategy',
      'Content Understanding', 'Context Analysis', 'Genre Recognition',
      'Reading Fluency', 'Information Extraction', 'Reading Retention',
      'Text Interpretation', 'Reading Assessment', 'Literary Analysis'
    ]
  },
  {
    name: 'Writing and Composition',
    skills: [
      'Written Expression', 'Grammar Usage', 'Sentence Structure',
      'Paragraph Development', 'Essay Writing', 'Creative Writing',
      'Technical Writing', 'Academic Writing', 'Business Writing',
      'Writing Style', 'Editing Skills', 'Proofreading',
      'Writing Clarity', 'Writing Organization', 'Writing Voice'
    ]
  },
  {
    name: 'Grammar and Syntax',
    skills: [
      'Grammar Rules', 'Syntax Structure', 'Parts of Speech',
      'Sentence Formation', 'Tense Usage', 'Verb Conjugation',
      'Grammar Analysis', 'Error Correction', 'Language Structure',
      'Grammar Application', 'Syntax Analysis', 'Language Patterns',
      'Grammar Teaching', 'Rule Understanding', 'Grammar Practice'
    ]
  },
  {
    name: 'Vocabulary and Word Usage',
    skills: [
      'Vocabulary Building', 'Word Selection', 'Synonym Usage',
      'Antonym Recognition', 'Word Relationships', 'Context Usage',
      'Word Formation', 'Vocabulary Range', 'Word Meaning',
      'Term Definition', 'Usage Examples', 'Word Families',
      'Vocabulary Teaching', 'Word Learning', 'Usage Practice'
    ]
  },
  {
    name: 'Translation and Interpretation',
    skills: [
      'Language Translation', 'Simultaneous Interpretation', 'Consecutive Interpretation',
      'Document Translation', 'Cultural Translation', 'Technical Translation',
      'Literary Translation', 'Legal Translation', 'Medical Translation',
      'Business Translation', 'Translation Tools', 'Interpretation Skills',
      'Translation Quality', 'Language Accuracy', 'Context Adaptation'
    ]
  },
  {
    name: 'Cultural and Contextual',
    skills: [
      'Cultural Understanding', 'Idiomatic Expressions', 'Cultural Context',
      'Language Customs', 'Social Norms', 'Cultural References',
      'Language History', 'Cultural Sensitivity', 'Regional Variations',
      'Language Evolution', 'Cultural Integration', 'Context Recognition',
      'Cultural Adaptation', 'Language Heritage', 'Cultural Communication'
    ]
  },
  {
    name: 'Language Teaching',
    skills: [
      'Teaching Methods', 'Curriculum Development', 'Lesson Planning',
      'Student Assessment', 'Teaching Materials', 'Language Activities',
      'Error Correction', 'Progress Monitoring', 'Teaching Strategy',
      'Learning Support', 'Teaching Tools', 'Student Engagement',
      'Teaching Techniques', 'Learning Assessment', 'Teaching Innovation'
    ]
  },
  {
    name: 'Digital Language Skills',
    skills: [
      'Language Software', 'Digital Tools', 'Online Learning',
      'Language Apps', 'Digital Resources', 'E-learning Platforms',
      'Virtual Classrooms', 'Language Technology', 'Digital Assessment',
      'Online Teaching', 'Digital Materials', 'Technology Integration',
      'Digital Literacy', 'Online Resources', 'Digital Communication'
    ]
  },
  {
    name: 'Professional Language',
    skills: [
      'Business Communication', 'Professional Writing', 'Technical Language',
      'Industry Terminology', 'Professional Presentation', 'Report Writing',
      'Business Correspondence', 'Professional Translation', 'Corporate Communication',
      'Professional Speaking', 'Business Terminology', 'Professional Standards',
      'Language Etiquette', 'Professional Style', 'Business Protocol'
    ]
  },
  {
    name: 'Language Assessment',
    skills: [
      'Proficiency Testing', 'Skill Evaluation', 'Progress Assessment',
      'Level Determination', 'Test Development', 'Assessment Methods',
      'Performance Measurement', 'Evaluation Tools', 'Testing Standards',
      'Assessment Strategy', 'Result Analysis', 'Feedback Provision',
      'Assessment Design', 'Quality Control', 'Certification Standards'
    ]
  }
];

// Export flattened list for backward compatibility
export const LANGUAGE_SKILLS = LANGUAGE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
